import { Link } from 'react-router-dom';

/**
 * Reemplaza <Breadcrumbs> de AbstractElements en las pantallas migradas.
 * `actions` son los botones de la derecha (Excel, Crear orden…).
 */
export const PageHeader = ({ title, crumbs = [], actions }) => (
  <div className="ui-page-header">
    <div>
      <h1 className="ui-page-header__title">{title}</h1>
      {crumbs.length > 0 && (
        <nav className="ui-crumbs" aria-label="Ruta de navegación">
          <i className="ri-home-4-line" />
          {crumbs.map((crumb, i) => {
            const isLast = i === crumbs.length - 1;
            return (
              <span key={crumb.label} className="ui-crumbs__item">
                {i > 0 && <span className="ui-crumbs__sep">/</span>}
                {crumb.to && !isLast ? (
                  <Link to={crumb.to}>{crumb.label}</Link>
                ) : (
                  <span className={isLast ? 'ui-crumbs__leaf' : undefined}>{crumb.label}</span>
                )}
              </span>
            );
          })}
        </nav>
      )}
    </div>
    {actions && <div className="ui-page-header__actions">{actions}</div>}
  </div>
);

export default PageHeader;
